









import { Vue, Component } from 'vue-property-decorator';

import NotificationList from '@/components/notification/NotificationList.vue';

import NotificationsModule from '@/store/modules/notifications';

import { Notification } from '@/components/notification/types';
import { sendNotificationRead } from '@/api/push';
import responseHandler from '@/store/modules/responseHandler';

@Component({
    components: {
        NotificationList,
    },
})
export default class AppNotifications extends Vue {
    
    get notifications() {
        return NotificationsModule.notifications;
    }

    async removeNotification(notification: Notification) {
        NotificationsModule.remove(notification);
        
        try {
            await sendNotificationRead(notification.id);
        } catch(error) {
            responseHandler.showNotify({ message: error, type: 'fail' });
        }
    }
}
